
import { computed, ComputedRef, defineComponent, PropType } from "vue";
import { useStore } from "vuex";
import { StateType as UserStateType } from "@/store/user";
import { hasPermissionRouteRoles } from "@/utils/routes";


interface PermissionSetupData {
    isPermission: ComputedRef<boolean>;
}

export default defineComponent({
    name: 'Permission',
    props: {
        roles: {
            type: [String , Array] as PropType<string[] | string>,
        }
    },
    setup(props): PermissionSetupData {
        const store = useStore<{user: UserStateType}>(); 

        // 是否有权限
        const isPermission = computed(()=> hasPermissionRouteRoles(store.state.user.currentUser.roles, props.roles));

        return {
            isPermission
        }

    }
})
